import {Section, SectionType} from './section';
export class ContactInfo {
  sections: Section[] = [];

  constructor(public data: any) {
    const json: JSON = data['contacts'];

    for (const section of json['sections']) {
      this.sections.push(new Section(section, SectionType.Persons));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/contact-info.ts